export default {"src":"/_next/static/media/logo.35228807.svg","height":140,"width":155,"blurWidth":0,"blurHeight":0};